import { Dialog, DialogModule } from "@angular/cdk/dialog";
import { CommonModule, DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { Client, CtaPageComponent } from "@interfaces";
import { GtagService } from "src/app/containers/gtag/gtag.service";
import { LeadDialogComponent } from "src/app/dialogs/lead-dialog/lead-dialog/lead-dialog.component";
import { ReferralFormComponent } from "src/app/dialogs/referral-form/referral-form/referral-form.component";
import { calculateButtonClasses, calculateButtonStyle } from "src/app/helpers/buttons";
import { SubdomainService } from "src/app/rest/subdomain.service";
import { ComponentActionsService } from "../../services/component-actions.service";
import { AbstractComponent } from "../abstract-component";
import { ApplyButtonComponent } from "../apply-button/apply-button.component";

@Component({
    selector: "app-cta",
    templateUrl: "./cta.component.html",
    styleUrls: ["./cta.component.css"],
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        DialogModule,
        LeadDialogComponent,
        ReferralFormComponent,
        ApplyButtonComponent,
    ],
})
export class CtaComponent extends AbstractComponent implements OnInit {
    public component: CtaPageComponent;
    public buttonStyle = {};
    public buttonClasses = [];
    public client: Client;

    constructor(
        protected actionsService: ComponentActionsService,
        private gtag: GtagService,
        private dialog: Dialog,
        private subdomain: SubdomainService,
        @Inject(DOCUMENT) private document
    ) {
        super(actionsService);
    }

    ngOnInit() {
        this.subdomain.getClient().subscribe((client: Client) => {
            this.client = client;
            this.setupAppearance();
        });
    }

    private setupAppearance() {
        this.buttonStyle = calculateButtonStyle(this.component.buttonConfig, this.client);
        this.buttonClasses = calculateButtonClasses(this.component.buttonConfig);
    }

    public onClick() {
        switch (this.component.ctaType) {
            case "refer":
                this.openReferDialog();
                break;
            case "lead":
                this.openLeadDialog();
                break;
            case "row":
                this.scrollToRow();
                break;
        }

    }

    public openLeadDialog() {
        this.gtag.fireOpenLeadDialogEvent();

        this.subdomain.getClient().subscribe((client: Client) => {
            const dialogRef = this.dialog.open(LeadDialogComponent, {
                maxWidth: "600px",
                panelClass: "low-padding-dialog",
                data: {
                    client,
                    page: this.page,
                    captureJobIntent: false,
                    captureCV: this.component.captureCV,
                    title: this.component?.dialogTitle,
                },
            });

            dialogRef.closed.subscribe((result) => {
                if (result) {
                    this.gtag.fireLeadEvent();
                }
            });
        });
    }

    public openReferDialog() {
        this.dialog.open(ReferralFormComponent, {
            width: "650px",
            maxWidth: "95vw",
            panelClass: "low-padding-dialog",
            data: { job: this.job },
        });

        this.gtag.fireOpenReferDialogEvent(this.job?._id, this.job?.title);
    }

    public scrollToRow() {
        this.document.getElementById(`template-row-${this.component.target}`).scrollIntoView({ behavior: "smooth" });
    }
}
